import { AcademicLevel, Accompagnateurs, Availabilities, CampaignId, Campus, Consentement, Email, FirstName, LastName, MobilePhoneRequired, SlotId, WishedProgramm } from "services/validation"
import * as Yup from "yup"

const schema = Yup.object().shape({
  ...Accompagnateurs,
  ...Availabilities,
  ...CampaignId,
  ...Consentement,
  cursus: Yup.string().required(`Vous devez choisir un cursus d'intérêt`),
  lead: Yup.object().shape({
    ...AcademicLevel,
    ...Campus,
    ...Email,
    ...FirstName,
    ...LastName,
    ...MobilePhoneRequired,
    Speciality__c: Yup.string().when('Undecided__c', {
      is: (undecided) => undecided !== true,
      then: (schema) => schema.required(`Vous devez choisir un programme d'intérêt`),
      otherwise: (schema) => schema.notRequired()
    })
  }),
  ...SlotId
})

export default schema
